// extracted by mini-css-extract-plugin
export default {"compositions_view":"CompositionsView_compositions_view__02xRo","dark":"CompositionsView_dark__5hqCa"};